import type { Application } from '../../../lib/api'
import { ValidiFIStatusCard } from '../../wizard/ValidiFIStatusCard'

export function VerificationContext({ app }: { app: Application }) {
  return (
    <div style={{ padding: '20px' }}>
      <h3 style={{ fontSize: '15px', fontWeight: 600, marginBottom: '12px', color: '#111827' }}>
        Bank Validation
      </h3>
      <ValidiFIStatusCard application={app} />
    </div>
  )
}
